import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200 last:border-b-0">
      <button
        onClick={onClick}
        className="w-full py-4 px-5 flex items-start justify-between text-left hover:bg-gray-50 transition-colors"
      >
        <span className="font-medium text-gray-900 pr-8 leading-relaxed">
          {question}
        </span>
        <ChevronDown
          className={`w-5 h-5 text-red-500 flex-shrink-0 transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-5 pb-4 text-gray-600 leading-relaxed">
          {answer}
        </div>
      </div>
    </div>
  );
};

export default function RentalFAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "For out of station minimum 300km fare charges will be applicable",
      answer: "When traveling outside the city limits, a minimum distance charge of 300 kilometers applies regardless of the actual distance traveled."
    },
    {
      question: "Garage to Garage Calculation: Time and kilometers will be calculated from our office (garage) to our office (garage)",
      answer: "All trip calculations including distance and time start from our garage location and end when the vehicle returns to the garage."
    },
    {
      question: "Permit, Parking, and Toll Fees: These charges will be billed at actuals",
      answer: "Additional costs such as permits, parking fees, and toll charges will be charged based on actual expenses incurred during the trip."
    },
    {
      question: "Luggage Disclaimer: Luggage carried in the vehicle is at the passenger's risk",
      answer: "We are not responsible for any loss or damage to luggage. Passengers are advised to keep their belongings secure and insured if necessary."
    },
    {
      question: "Fuel Price Adjustment: Rates are subject to change in line with fuel price fluctuations",
      answer: "Rental rates may be adjusted based on fuel price changes. Current rates: Diesel: ₹85 to ₹95 per liter, Petrol: ₹95 to ₹105 per liter."
    },
    {
      question: "Flight Delays: Drivers track flight status. However, customers are requested to update in case of major schedule changes",
      answer: "While our drivers monitor flight schedules, please inform us of any significant delays or changes to ensure smooth pickup arrangements."
    },
    {
      question: "Waiting Time: Any waiting time during the trip will be considered part of the total rental duration",
      answer: "All time spent waiting during your journey will be included in the overall rental period and billing."
    },
    {
      question: "Driver & Vehicle: Urbania Nava Cabs Tours assigns verified and professional drivers only",
      answer: "Vehicle type will be as per the booking category (Urbania, Sedan, SUV, or Tempo). All drivers are verified and professionally trained."
    },
    {
      question: "Customer Responsibility: Customers are requested to maintain vehicle cleanliness",
      answer: "Damage to the vehicle interior/exterior caused by negligence will be chargeable. Please help us maintain the vehicle in good condition."
    },
    {
      question: "Company Rights:Urbania Navacabs Tour Rents reserves the right to deny or cancel a booking",
      answer: "The company reserves the right to refuse service or cancel bookings under certain circumstances to ensure safety and service quality."
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold text-blue-600 mb-3">
            Frequently Asked Questions
          </h1>
          <p className="text-gray-600">
            Everything you need to know about our rental services
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-gray-500 text-sm">
            Still have questions? Contact our support team for assistance.
          </p>
        </div>
      </div>
    </div>
  );
}